/* 商品選択 */
import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from '../axios';
import Shelf from '../molecules/Shelf';
import { product_image_path } from '../Const';

interface ListProp {
  list: ItemProp[];
}
interface ItemProp {
  id: string;
  item_name: string;
}

const ProductList: React.FC = () => {
  const [product_list, setProductList] = useState<ListProp['list']>([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const getProductList = async () => {
      try {
        const response = await axios.get('/applicant/api/product_list');
        setProductList(response.data);
      } catch (error) {
        console.error(error.message);
      }
    };
    getProductList();
  }, []);

  return (
    <Shelf label="商品選択" is_open={open} handleClick={() => setOpen(!open)}>
      <div id="product-list">
        <Row>
          <ProductItemList list={product_list} />
        </Row>
      </div>
    </Shelf>
  );
};

const ProductItemList: React.FC<ListProp> = ({ list }) => {
  const elements: Array<JSX.Element> = [];

  list.map((item: ItemProp, index) => {
    elements.push(
      <Col xl={4} lg={4} md={4} sm={12} xs={12} key={index}>
        <ProductItem key={index} id={item.id} item_name={item.item_name} />
      </Col>
    );
  });
  return <>{elements}</>;
};

const ProductItem: React.FC<ItemProp> = ({ id, item_name }) => {
  const handleClick = useCallback((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();

    // APIリクエストを実行し、選択した商品を保存する
    const params = {
      id,
    };
    axios.post('/applicant/api/product_select', params).then((res: any) => {
      // TODO wakasugi.y 成功だった場合は事前審査申込情報画面に遷移する
      if (res.data.result) {
        console.log(res);
      }
    });
  }, []);
  return (
    <a href="#" onClick={handleClick}>
      <div className="product-image">
        <img src={`${product_image_path}${id}.png`} alt={item_name} />
      </div>
      <p>{item_name}</p>
    </a>
  );
};

export default ProductList;
